import * as React from "react";

const StorageIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41">
    <path
      fill="#171718"
      d="M13 30q-.825 0-1.412-.587A1.93 1.93 0 0 1 11 28V16.725q-.45-.274-.725-.713A1.86 1.86 0 0 1 10 15v-3q0-.824.587-1.413A1.93 1.93 0 0 1 12 10h16q.824 0 1.413.587Q30 11.175 30 12v3q0 .574-.275 1.012t-.725.713V28q0 .824-.587 1.413A1.93 1.93 0 0 1 27 30zm0-13v11h14V17zm-1-2h16v-3H12zm5 7h6v-2h-6z"
    ></path>
  </svg>
);

export default StorageIconSVG;
